import {useEffect, useState} from "react";
import {get_series} from "../../../server/requests";
import RowList from "../../Row_List/RowList";
import Loading from "../../Loading/Loading";

export default function TvShows({isGuest}) {

    const [listTvShows, setListTvShows] = useState([])
    const [showLoading, setShowLoading] = useState(false)

    useEffect(() => {
        setShowLoading(true)
        get_series({}, data => {
            setListTvShows([...data])
            setShowLoading(false)
        }, err => console.log(err))
    }, [])

    return (
        <div className="container">
            <div className="list_tv_shows">
                {showLoading ?
                    <Loading/>
                    : listTvShows.map((row, index) => {
                        return row.movies && row.movies.length ?
                            <RowList
                                key={row.id}
                                title={row.name}
                                type={'movies'}
                                row={row}
                                array={row.movies}
                                rowIndex={index}
                                isGuest={isGuest}

                            /> : null
                    })}
            </div>
        </div>
    )
}